module.exports = __webpack_public_path__ + "523d5703b7cebe1a0c13255de79e3979.png";